import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateHeaderExport from './components/template-header-export';
import TemplateOrderInfoExport from './components/template-order-info-export';
import TemplateOrderInfoItemExport from './components/template-order-info-item-export';
import TemplateFooterExport from './components/template-footer-export';

interface IProps {
  data: IOrder;
}

const TM19 = ({ data }: IProps) => {
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeaderExport titleEn="PROFORMA INVOICE" />
      <TemplateOrderInfoExport
        data={data}
        code={data.ivNo}
        titleEn="PROFORMA INVOICE"
      />
      <TemplateOrderInfoItemExport
        data={data}
        isShowPrice
        amount={data?.summary || 0}
        customerCode={data?.customer?.code}
        ivNo={data?.ivNo}
      />
      <TemplateFooterExport data={data} docNo={data?.code} />
    </div>
  );
};

export default TM19;
